<template>
  <div
    class="menu">
    <el-row class="menu-container">
      <el-col
        :span="10"
        class="section-black">
        NEGRO
      </el-col>
      <el-col
        :span="14"
        class="section-white">
        BLANCO
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'MenuHome'
}
</script>

<style lang="scss" scoped>
  .menu {
    background-color: white;
    height: 300px;
    width: 100%;
    overflow: hidden;
    position: absolute;
    z-index: 199;
    top: 70px;
    @media #{$iPhone} {
      height: calc(100vh - 50px) !important;
      overflow: hidden !important;
    }
    @media #{$iPhoneLandscape} {
      top: 50px;
      height: calc(100vh - 50px) !important;
    }
  }

  .blur{
    background: url('/static/images/main-banner.jpg') no-repeat center center fixed;;
    background-size: cover;
    overflow: hidden;
    top: 70px;
    filter: blur(10px);
    height: 300px;
    z-index: 199;
  }
  .content-menu{
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    color: white;
    .section-black{
      background-color: rgba(black, .4);
      height: 100%;
    }
    .section-white{
      background-color: rgba(white, .4);
      height: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/menu/menu-home.vue